import React, {useState } from "react";
import { useNavigate } from "react-router-dom";

const BestServices = ({ labelDetailData, servicesDetailData, loading }) => {
  const navigate = useNavigate();

  const noImage = "/assets/images/no-image.png";
const [isImageLoaded, setIsImageLoaded] = useState(false); // Track image load state
  const moveOutButtonClick = (serviceName, serviceId) => {
    const slug =
      "/" +
      serviceName
        .toLowerCase()
        .replace(/\//g, "-")
        .replace(/\s+/g, "-")
        .replace(/[^a-z0-9-]/g, "");

    navigate(slug, {
      state: { serviceId },
    });
  };

  // Memoized label lookup
  const labelMap = React.useMemo(() => {
    if (labelDetailData?.code !== 200 || !labelDetailData.data) return {};
    const map = {};
    labelDetailData.data.forEach(({ vLabel, tText }) => {
      map[vLabel] = tText;
    });
    return map;
  }, [labelDetailData]);

  const ourServiceHomeHeading = labelMap["LBL_HOME_OUR_SERVICES_HEADING"];
  const ourServiceSubHomeHeading =
    labelMap["LBL_HOME_OUR_SERVICES_SUB_HEADING"];
  const ourServiceAboutHeading =
    labelMap["LBL_ABOUT_US_NEVER_WAIT_FOR_A_CLEANING_HEADING"];
  const ourServiceSubAboutHeading =
    labelMap["LBL_ABOUT_US_NEVER_WAIT_FOR_A_CLEANING_SUB_HEADING"];

  const services =
    servicesDetailData?.code === 200 ? servicesDetailData.data : [];

  const handleViewServicesClick = () => {
    navigate("/services");
  };

  return (
    <section
      className="service-section ptb-100"
      
      // style={{ backgroundImage: "url('/assets/images/service-bg.webp')" }}
      style={{ position: "relative", overflow: "hidden" }}
    >
     <img
          src={'/assets/images/service-bg.webp'}
          alt="MopForce Banner"
          fetchPriority="high"
          decoding="async"
          loading="eager"
          onLoad={() => setIsImageLoaded(true)} // Image loaded callback
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            position: "absolute",
            top: 0,
            left: 0,
            zIndex: -1,
            filter: isImageLoaded ? "none" : "blur(10px)", // Apply blur initially
            transition: "filter 0.3s ease-out", // Smooth transition once image is loaded
          }}
        />
      <div className="container">
        <div className="service-contentDiv">
          <div className="row align-items-center">
            <div className="col-lg-9">
              <h2 className="main-title white-title">
                {ourServiceHomeHeading || ourServiceAboutHeading}
              </h2>
              <p className="white-title mb-0">
                {ourServiceSubHomeHeading || ourServiceSubAboutHeading}
              </p>
            </div>
            <div className="col-lg-3">
              <div className="section-headbtnDiv">
                <button
                  className="success-orangebtn"
                  onClick={handleViewServicesClick}
                >
                  View All
                </button>
              </div>
            </div>
          </div>

          {loading ? (
            <div style={{ height: "720px" }}></div>
          ) : services?.length > 0 ? (
            <div className="row pt-50 g-4">
              {services.map((service, index) => (
                <div className="col-xl-3 col-lg-6 col-md-6" key={index}>
                  <div className="bestservice-card">
                    <img
                      className="bestservice-img"
                      src={
                        service?.vWebpImage &&
                        !service?.vWebpImage.endsWith(null)
                          ? service?.vWebpImage
                          : noImage
                      }
                      width="70"
                      height="70"
                      alt="Service"
                      loading="lazy"
                    />
                    <div className="bestservice-content">
                      <h3 className="service-title">{service.vServiceName}</h3>
                      <p>{service.tDescription}</p>
                      <button
                        className="login-headerbtn white-borderbtn"
                        onClick={() =>
                          moveOutButtonClick(
                            service.vServiceName,
                            service.iServiceId
                          )
                        }
                      >
                        READ MORE{" "}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="8"
                          height="14"
                          viewBox="0 0 8 14"
                          fill="none"
                        >
                          <path
                            d="M1 1L7 7L0.999999 13"
                            stroke="white"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="col-12 text-center text-white py-3">
              No Data Found
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default BestServices;
